import { createContext, useMemo, useState } from "react";

interface ShowIntroContextValue {
  showIntro: boolean;
  setShowIntro: (state: boolean) => void;
}

export const ShowIntroContext = createContext<ShowIntroContextValue>(
  {} as ShowIntroContextValue
);

export const ShowIntroProvider: React.FC = ({ children }) => {
  const [showIntro, setShowIntro] = useState(true);

  const value = useMemo(() => ({ showIntro, setShowIntro }), [showIntro]);

  return (
    <ShowIntroContext.Provider value={value}>
      {children}
    </ShowIntroContext.Provider>
  );
};
